<template>
  <el-dialog
    class="cbaas-download-dialog"
    :title="title"
    :visible.sync="showDialog"
    :lock-scroll="true"
    :show-close="false"
    :top="top"
  >
    <div>
      <span v-if="downloading">{{ `正在下载 ${fileName}` }}</span>
      <span v-else>{{ fileName }}</span>
    </div>
    <span slot="footer">
      <el-button :disabled="downloading" @click="cacel">{{ cancelText }}</el-button>
      <el-button
        type="primary"
        :disabled="downloading"
        :loading="downloading"
        @click="startDownload()"
        >{{ sureText }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'DownloadDialog',
  props: {
    dialogVisible: Boolean,
    title: {
      type: String,
      default: '下载'
    },
    sureText: {
      type: String,
      default: '确 定'
    },
    cancelText: {
      type: String,
      default: '取 消'
    },
    top: {
      type: String,
      default: '40vh'
    },
    fileUrl: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    storeFileName: {
      type: Function,
      default: undefined
    },
    metaData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      downloading: false,
      showDialog: false
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    },
    chainId: function(val) {
      console.log(val)
    }
  },
  methods: {
    cacel() {
      this.showDialog = false
      this.downloading = false
    },
    startDownload() {
      this.downloading = true
      let self = this
      let filename = this.fileName
      let fileUrl = this.fileUrl
      new Promise(async (resolve, reject) => {
        try {
          await self.downloadFile(filename, fileUrl)
          self.$message.success('下载成功')
          self.showDialog = false
          self.downloading = false
          resolve(true)
        } catch (err) {
          let msg = `下载 ${filename} 失败：${err.message}`
          self.$message.warning(msg)
          self.showDialog = false
          self.downloading = false
          console.log(msg)
        }
      })
        .then(data => {
          console.log('下载完成')
        })
        .catch(err => {
          let msg = `下载 ${filename} 失败：${err}`
          self.$message.warning(msg)
          self.showDialog = false
          self.downloading = false
          console.log(msg)
        })
    },
    downloadFile(fileName, fileUrl) {
      let self = this
      return new Promise((resolve, reject) => {
        const baseUrl = self.g_Config.BASE_URL + fileUrl
        let xhr = new XMLHttpRequest()
        xhr.open('get', baseUrl, true)
        xhr.responseType = 'blob' // 转换流
        xhr.setRequestHeader(
          'Authorization',
          'Bearer ' + localStorage.getItem('cbaas_system_Token')
        )
        xhr.onload = function() {
          if (xhr.status === 200) {
            try {
              let blob = xhr.response
              let a = document.createElement('a')
              let url = window.URL.createObjectURL(blob)
              a.href = url
              a.download = self.storeFileName ? self.storeFileName(xhr, self.metaData) : fileName // 文件名
              a.click()
              window.URL.revokeObjectURL(url)
              resolve(true)
            } catch (err) {
              reject(err)
            }
          } else {
            reject('status: ' + xhr.status + '\n response: ' + xhr.response)
          }
        }
        xhr.send()
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.cbaas-download-dialog {
  @include adaptation(
    (
      --cbaas-download-dialog-width: 660px,
      --cbaas-download-dialog-body-padding-bottom: 16px
    )
  );
  /deep/ .el-dialog {
    width: var(--cbaas-download-dialog-width);

    .el-dialog__body {
      padding-bottom: var(--cbaas-download-dialog-body-padding-bottom);
    }
  }
}
</style>
